export const detectEsicBranchIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE ESIC BRANCH
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(esic branch)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("branch") &&
        cleaned.includes("esic")
    ) {
        return {
            intent: "delete_branch_esic",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE ESIC BRANCH
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(esic branch)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("esic") &&
        cleaned.includes("branch")
    ) {
        return {
            intent: "create_esic_branch",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
